import type { PersonalDataItemViewModelExtended } from './personal-data-item-view-model-extended';

export function personalDataItemsInComputers(
  personalDataItems: PersonalDataItemViewModelExtended[],
  computerId: string,
): PersonalDataItemViewModelExtended[] {
  computerId = computerId ?? '';
  return personalDataItems.filter((p) => {
    const s = p.storageUnit ?? '';
    return s === computerId;
  });
}
